<template>
    <div class="i-form" >
        <div class="form-column" v-for='column in columns' :style="columnStyle">
            <drag-mover v-if="idx%columns === column-1 && showif(path)" 
                v-for="(path,idx) in Object.keys(scheme)" 
                :sstyle="makeGrid(schemeParsed[path])"
                :key="'input-'+idx"
                :pos="layout&&layout[path]"
                @input="(pos)=>savePos(path, pos)"
                :edit="editMode"
            >
                <multi-input 
                    :value="form_data.getByPath(path)" 
                    @input="(v)=>setByPath(path,v)" 
                    :config="schemeParsed[path]"
                />
            </drag-mover>
        </div>
        <div class="text-right">
            <btn :disabled="!changed" v-if="controls" l="Сохранить" t="s" s="m" i="save" @press="save" />
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import multiInput from "./multi-input.vue";
import dragMover from "./i-drag-mover.vue";
export default {
    components: { multiInput,dragMover },
    name: 'i-form',
    props: {
        padding: 0,

        editMode: {
            type: Boolean,
            default: false
        },
        changedOnly: {
            type: Boolean,
            default: false
        },
        grid: {
            type: Boolean,
            default: false
        },
        name: { type: String, default: "" },
        controls: { type: Boolean, default: false },
        columns: {
            type: Number,
            default: 1
        },
        value: {
            type: Object
        },
        
        layout: {
            type: Object
        },

        width: {type: [String,Number]},
        height: {type: [String,Number]},
        data: {
            type: Object,
            default () {
                return {
                    name: 'Arman'
                };
            }
        },
        scheme: {
            type: Object,
            default () {
                return {
                    "name": { type: "string", label: 'Имя пользователя' }
                }
            }
        }
    },
    methods: {
        savePos(path,pos){
            this.new_coords[path] = pos;
            console.warn('SAVE THIS:',JSON.stringify(this.new_coords));
        },
        makeGrid(config){
            let {editMode, layout} = this;
            if(!config.pos) return {};
            let {x,y,w,h} = config.pos;
            if(x === undefined || y === undefined || w === undefined || h === undefined) return {};
            return {
                width: (w)+'px',
                height: (h)+'px',
                top: (y)+'px',
                left: (x)+'px'
                //overflow:'hidden'
            }
        },
        setByPath(p, d) {
            console.log(p, d)
            this.changed = true;
            this.$emit("changed", this.changed);
            this.form_data.setByPath(p, d);
        },
        isRequiredFieldFilled() {
            let { schemeParsed, form_data } = this;
            let error = false;
            Object.keys(schemeParsed).forEach((path) => {
                if (schemeParsed[path].required) {
                    if (!form_data.getByPath(path)) {
                        alert("Заполните обязательные поля: " + schemeParsed[path].label);
                        error = true;
                    }
                }
            });
            return !error;
        },
        save() {
            if (!this.isRequiredFieldFilled()) return;
            this.changed = false;
            //console.log(this.form_data.getChanged())
            if (this.changedOnly) {
                this.$emit('input', this.form_data.getChanged());
            } else {
                this.$emit('input', this.form_data);
            }
            _i.bus.$emit('notify', {
                title: "Успешно сохранено",
                text: "Форма успешно сохранена"
            })
            //alert("Успешно сохранено");
        },
        showif(path) {
            let { schemeParsed, data } = this;
            let config = schemeParsed[path];
            if (config.showif && typeof config.showif === "function") {
                return config.showif(data);
            } else return true;
        }, 
        onFormSave(name) {
            if (this.changed && (!name && !this.name || name === this.name)) {
                this.save();
            }
        }
    },
    data() {
        return {
            changed: false,
            form_data: new iFormData(),
            new_coords: {}
        }
    },
    watch: {
        data(nw, old) {
            if (!this.changed) this.form_data = new iFormData(nw);
        }
    },
    watch:{
        value(nw,ol){
            this.form_data = new iFormData(nw);
        }
    },
    beforeMount() {
        let self = this;
        if (this.value) {
            this.form_data = new iFormData(this.value);
        } else {
            this.form_data = new iFormData(this.data);
        }
        _i.bus.$on('save-form', this.onFormSave);
    },
    computed: {
        schemeParsed() { // "string" -> {type:"string"}
            let { scheme, columns } = this;
            return Object.keys(scheme).reduce((ns, prop) => {
                if (typeof scheme[prop] === "object") {
                    ns[prop] = scheme[prop];
                } else {
                    ns[prop] = { type: scheme[prop] };
                }
                return ns;
            }, {})
        },
        columnStyle(){
            let {padding, columns, grid, width, height} = this;
            let stl = {padding:padding+'px', paddingBottom:0};
            if(height) stl.height = height+'px';
            stl.width = (100/columns)+'%';
            return stl;
        }
    },
    beforeDestroy() {
        _i.bus.$off('save-form', this.onFormSave);
        if (this.changed) {
            if (confirm('Сохранить изменения?')) {
                this.save();
            }
        }
    }
}
</script>
<style lang="css" scoped>
.i-form{
    overflow:hidden;
}
.form-column {
    float: left;
    position:relative;
    overflow:hidden;

}
</style>